import * as React from "react";
import { observer } from "mobx-react-lite";
import { BusinessInfoContext, BusinessInfoState } from "./BusinessInfo.state";
import { BusinessInfoForm } from "./BusinessInfo.form";
import { usePassportStore } from "src/stores";
import {
  LegacyBusinessInfoContext,
  LegacyBusinessInfoState,
} from "./legacy/LegacyBusinessInfoState";
import { LegacyBusinessInfoForm } from "./legacy/LegacyBusinessInfo.form";

export const PassportBusinessInfo = observer(() => {
  const passportStore = usePassportStore();

  return passportStore.isImprovementEnabled ? (
    <BusinessInfoContext.Provider value={new BusinessInfoState(passportStore)}>
      <BusinessInfoForm />
    </BusinessInfoContext.Provider>
  ) : (
    <LegacyBusinessInfoContext.Provider
      value={new LegacyBusinessInfoState(passportStore)}
    >
      <LegacyBusinessInfoForm />
    </LegacyBusinessInfoContext.Provider>
  );
});
